import { DateClass } from '@/common/class/date.class'

export default function (value) {
  let date = DateClass.parseDate(value)
  return DateClass.getFormattedDate(date, 'Y-m-d')
}
